// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Subheader.module.css */

.Subheader_height__WfTVU {
  height: 20px;
}

.Subheader_logo__KQEoE {
  display: flex;
  align-items: center;
  gap: 40px;
  margin-bottom: 2px;
}

h6 {
  font-weight: 500;
  font-size: 18px;
  font-family: roboto;
  top: 4px;
  position: relative;
}

.Subheader_logo__KQEoE img {
  height: 100%; /* Adjust logo size to fit within height */
  object-fit: contain; /* Maintain aspect ratio */
}
.Subheader_margin__4vdOZ {
  margin-bottom: 6px;
}
.Subheader_image__B\\+tMV {
  cursor: pointer;
  /* fill: white;
   */
  /* color: black; */
}
.Subheader_customChatIcon__Sm9XB {
  background-color: #ff6600; /* Orange color */
  border-radius: 50%;
  padding: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.Subheader_icon__\\+jWRW {
  /* color: white; */
  font-size: 24px; /* Adjust size as needed */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/BuzzCom/Style/Subheader.module.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,0CAA0C;EACxD,mBAAmB,EAAE,0BAA0B;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf;IACE;EACF,kBAAkB;AACpB;AACA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe,EAAE,0BAA0B;AAC7C","sourcesContent":["/* Subheader.module.css */\n\n.height {\n  height: 20px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  margin-bottom: 2px;\n}\n\nh6 {\n  font-weight: 500;\n  font-size: 18px;\n  font-family: roboto;\n  top: 4px;\n  position: relative;\n}\n\n.logo img {\n  height: 100%; /* Adjust logo size to fit within height */\n  object-fit: contain; /* Maintain aspect ratio */\n}\n.margin {\n  margin-bottom: 6px;\n}\n.image {\n  cursor: pointer;\n  /* fill: white;\n   */\n  /* color: black; */\n}\n.customChatIcon {\n  background-color: #ff6600; /* Orange color */\n  border-radius: 50%;\n  padding: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  /* color: white; */\n  font-size: 24px; /* Adjust size as needed */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"height": `Subheader_height__WfTVU`,
	"logo": `Subheader_logo__KQEoE`,
	"margin": `Subheader_margin__4vdOZ`,
	"image": `Subheader_image__B+tMV`,
	"customChatIcon": `Subheader_customChatIcon__Sm9XB`,
	"icon": `Subheader_icon__+jWRW`
};
export default ___CSS_LOADER_EXPORT___;
